import lodashString from 'lodash/string'
import snakeCase from 'lodash/snakeCase'

function toTitleCase (str) {
  return lodashString.startCase(str).replace(/\s/g, '')
}

export default {
  toCamelCase: lodashString.camelCase,
  toKebabCase: lodashString.kebabCase,
  toStartCase: lodashString.startCase,
  toSnakeCase: snakeCase,
  toTitleCase
}
